import { DataManager } from '../../core/data-manager';
import { toast } from 'react-toastify';



export async function preDelete(entity, id) {

    if (entity === "customer_order") {
        let constraints = [{ "fieldName": "idCustomerOrder", type: "value", value: id }]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var res = await DataManager.searchItems('supplier_order', 1, 100, sorting, '', [], constraints)
        if (res.success === 1) {
            if (res.body.length > 0) {
                toast.error("Attenzione! Non è possibile cancellare questo ordine perché sono già stati creati gli ordini fornitore.", { theme: 'colored', position: 'bottom-center' })
            } else {
                return {
                    success: 1,
                    message: ''
                }
            }
        }
    } else if (entity === "customer") {
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: id }]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var resOrder = await DataManager.searchItems('customer_order', 1, 100, sorting, '', [], constraints)
        var resOffer = await DataManager.searchItems('customer_offer', 1, 100, sorting, '', [], constraints)
        if (resOrder.success === 1 || resOffer.success === 1) {
            if (resOffer.body.length > 0 || resOrder.body.length > 0) {
                toast.error("Attenzione! Non è possibile cancellare questo ordine perché sono già stati creati gli ordini fornitore.", { theme: 'colored', position: 'bottom-center' })
            } else {
                return {
                    success: 1,
                    message: ''
                }
            }
        }
    }
    else if (entity === 'customer_order_delivery') {
        try {
            const deliveryResponse = await DataManager.getItem('customer_order_delivery', id);
            if (deliveryResponse.success !== 1 || !deliveryResponse.body || deliveryResponse.body.length === 0) {
                throw new Error(deliveryResponse.message || 'Impossibile recuperare i dettagli della consegna.');
            }

            const delivery = deliveryResponse.body[0];
            const statusValue = typeof delivery.status === 'string' ? delivery.status : delivery.status?.value;
            if (statusValue === '20_DELIVERED') {
                toast.error('Non è possibile cancellare una consegna già consegnata.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'Consegna già consegnata'
                };
            }

            const deliveryRows = Array.isArray(delivery.rows) ? delivery.rows : [];

            const customerOrderRowIds = Array.from(new Set(deliveryRows
                .map((row) => {
                    if (!row) {
                        return null;
                    }
                    if (row.idCustomerOrderRow && typeof row.idCustomerOrderRow === 'object') {
                        return row.idCustomerOrderRow.id;
                    }
                    return row.idCustomerOrderRow;
                })
                .filter((value) => value !== null && value !== undefined)
            ));

            if (!customerOrderRowIds.length) {
                toast.success('Consegna eliminata con successo.', { theme: 'colored' });
                return {
                    success: 1,
                    message: ''
                };
            }

            const updatePromises = customerOrderRowIds.map((rowId) =>
                DataManager.updateItem('customer_order_row', { status: { value: '10_RECEIVED', label: '10_RECEIVED' } }, rowId)
            );

            const updateResponses = await Promise.all(updatePromises);
            const hasFailure = updateResponses.some((res) => !res || res.success !== 1);
            if (hasFailure) {
                throw new Error('Impossibile aggiornare lo stato delle righe ordine cliente collegate.');
            }

            toast.success('Consegna eliminata con successo.', { theme: 'colored' });

            return {
                success: 1,
                message: ''
            };
        }
        catch (error) {
            console.error('Errore durante la verifica eliminazione consegna:', error);
            toast.error(error.message || 'Impossibile ripristinare lo stato delle righe ordine cliente.', { theme: 'colored' });
            return {
                success: 0,
                message: error.message || 'Errore durante la preparazione della cancellazione.'
            };
        }
    }
    else {
        return {
            success: 1,
            message: ''
        }
    }




}
